import React from 'react'

import { IconProps } from '../Types'

export const VoiceOutline = ({
  title,
  fill = 'currentColor',
  stroke = 'none',
  ref,
  ...props
}: IconProps = {}) => (
  <svg
    ref={ref}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    data-title="VoiceOutline"
    {...{ ...(title && { 'data-title': title }), fill, stroke, ...props }}
    dangerouslySetInnerHTML={{
      __html:
        (title === undefined ? '' : `<title>${title}</title>`) +
        '<path fill-rule="evenodd" d="m12,4c-.66,0-1.29.26-1.76.72-.47.46-.73,1.09-.73,1.74v4.85c0,.65.26,1.28.73,1.74.47.46,1.1.72,1.76.72s1.29-.26,1.76-.72c.47-.46.73-1.09.73-1.74v-4.85c0-.65-.26-1.28-.73-1.74-.47-.46-1.1-.72-1.76-.72Zm-3.19-.69c.84-.84,1.99-1.31,3.19-1.31s2.34.47,3.19,1.31c.84.84,1.32,1.97,1.32,3.15v4.85c0,1.18-.47,2.32-1.32,3.15-.84.84-1.99,1.31-3.19,1.31s-2.34-.47-3.19-1.31-1.32-1.97-1.32-3.15v-4.85c0-1.18.47-2.32,1.32-3.15Zm-3.8,7.69c.56,0,1.01.45,1.01,1,0,.69.13,1.37.4,2,.26.64.65,1.21,1.14,1.7.49.49,1.07.87,1.71,1.13.64.26,1.33.4,2.02.39h1.4c.69,0,1.38-.13,2.02-.39.64-.26,1.22-.65,1.71-1.13.49-.49.88-1.06,1.14-1.7.26-.64.4-1.32.4-2,0-.55.45-1,1.01-1,.56,0,1.01.45,1.01,1,0,.95-.19,1.89-.55,2.77-.37.88-.9,1.68-1.58,2.35s-1.48,1.2-2.37,1.57c-.79.32-1.63.51-2.48.54v1.78c0,.55-.45,1-1.01,1s-1.01-.45-1.01-1v-1.78c-.85-.03-1.69-.22-2.48-.54-.89-.36-1.69-.9-2.37-1.57-.68-.67-1.22-1.47-1.58-2.35-.37-.88-.55-1.82-.55-2.77,0-.55.45-1,1.01-1Z"/>',
    }}
  />
)

VoiceOutline.displayName = 'VoiceOutline'

export const tags = ['VoiceOutline', '']
